import { MaybeRef, toRef } from "vue";

import { useFetch } from "@/composables/tanstack/use-fetch";
import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { EProgramApplianceCategory } from "@/domains/v4b/program/program.types";

interface IFetchSitePlanningOverrideByApplianceCategoryArgs {
  siteId: MaybeRef<number>;
  applianceCategory: EProgramApplianceCategory;
}

export function useFetchSitePlanningOverrideByApplianceCategory() {
  return useFetch(
    (args: IFetchSitePlanningOverrideByApplianceCategoryArgs) => {
      const _siteId = toRef(args.siteId);

      return SitesQueryKeys.planningOverridesByApplianceCategory({
        siteId: _siteId.value,
        applianceCategory: args.applianceCategory,
      });
    },
    async (args: IFetchSitePlanningOverrideByApplianceCategoryArgs) => {
      const _siteId = toRef(args.siteId);

      return await KiliApi.getPlanningOverridesBySection({
        params: {
          siteId: _siteId.value,
          applianceCategory: args.applianceCategory,
        },
      });
    },
  );
}
